import React, { Component } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Category from "./category/Category";
import LandingPage from "./LandingPage";
import ProductPage from "./ProductPage";

// import { createBrowserHistory } from 'history'

export default class RouterContainer extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={LandingPage} />
                    <Route exact path="/category/:category_name" component={Category} />
                    <Route exact path="/category/:category_name/:brand" component={Category} />
                    <Route exact path="/product/:productId" component={ProductPage} />
                    <Route exact path='*' component={LandingPage} />
                </Switch>
            </Router>
        );
    }
}
